export default {
    transfer_reason: "",
    transfer_to_id: "",
    transfer_date: "",
    lot_id: "",
    floorplan: "",
    price: "",
    sqft: "",
    realtor_involved: "",
    realtor: "",
    realtor_office: "",
    realtor_phone: "",
    realtor_email: "",
    estimated_closing: "",
    sale_date: "",
    primary_first: "",
    primary_last: "",
    co_first: "",
    co_last: "",
    has_co: "",
    comments: "",
    beds: "",
    full_baths: "",
    stories: "",
    garage: "",
    half_baths: "",
    elevation: "",
    sale_type: "",
    label_floorplan: ''
}